<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md6>
        <v-dialog v-model="asignar_clave" persistent max-width="600">
          <v-card>
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title style="text-transform:uppercase">Asignando Contraseña</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-spacer></v-spacer>
            <v-card-text class="text-center">
              <v-alert
                :value="mensaje_proceso"
                type="warning"
                class="text-justify text-uppercase"
              >Procesando... Por favor espere</v-alert>
              <v-alert :value="mensaje_ok" type="success" class="text-justify text-uppercase">
                <span class="estilo_dos_columnas">Contraseña asignada satisfactoriamente.</span>
                <v-btn
                  color="orange darken-1"
                  class="white--text estilo_dos_columnas"
                  @click="login"
                >Acceder</v-btn>
              </v-alert>
              <v-alert :value="mensaje_error" type="error" class="text-justify text-uppercase">
                <span class="estilo_dos_columnas">Se presentó un problema, intente nuevamente.</span>
                <v-btn
                  color="orange darken-1"
                  class="white--text estilo_dos_columnas"
                  @click="asignar_clave = false"
                >Reintentar</v-btn>
              </v-alert>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-form v-model="validFAsignacionClave">
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title style="text-transform:uppercase">Acceso Representantes</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-alert
                :value="true"
                type="info"
                class="text-justify text-uppercase"
              >Asignación nueva contraseña</v-alert>
              <v-divider class="mx-1"></v-divider>
              <p class="text-center">
                <small class="text-uppercase">Por favor, digite su nueva contraseña y confírmela.</small>
              </p>
              <input type="hidden" name="token" :value="asignacion_clave.token.campo" />
              <input type="hidden" name="email" :value="asignacion_clave.email.campo" />
              <v-text-field
                label="Contraseña"
                name="password"
                id="password"
                prepend-icon="lock"
                autocomplete="new-password"
                #password
                type="password"
                v-model="asignacion_clave.password.campo"
                :rules="passwordRules"
                :error-messages="errors.collect(`${asignacion_clave.password.valido}`)"
                required
              ></v-text-field>
              <v-text-field
                label="Confirmar Contraseña"
                name="password_confirmation"
                id="password_confirmation"
                prepend-icon="lock"
                autocomplete="new-password_confirmation"
                #password
                type="password"
                v-model="asignacion_clave.password_confirmation.campo"
                :rules="passwordRules"
                :error-messages="errors.collect(`${asignacion_clave.password_confirmation.valido}`)"
                required
              ></v-text-field>
              <small
                class="font-weight-regular red--text text--lighten-1"
                style="padding-left: 33px;"
                v-if="(asignacion_clave.password.campo != asignacion_clave.password_confirmation.campo) && asignacion_clave.password.campo && asignacion_clave.password_confirmation.campo"
              >La nueva contraseña y su confirmación deben ser iguales</small>
            </v-card-text>
            <v-spacer></v-spacer>
            <v-card-actions style="display:flex; justify-content: space-between">
              <v-btn
                color="orange darken-1"
                class="white--text estilo_dos_columnas"
                style="width:250px"
                @click="login"
              >Cancelar</v-btn>
              <v-btn
                color="indigo darken-1"
                class="white--text estilo_dos_columnas"
                style="width:250px"
                @click="asignarNuevaClave"
                :disabled="!validFAsignacionClave || (asignacion_clave.password.campo != asignacion_clave.password_confirmation.campo)"
              >Asignar nueva contraseña</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import router from "../../../router/index.js";
import { EventBus } from "../../../EventBus";
import Usuario from "../../../services/RepresentanteService";

export default {
  data: () => ({
    validFAsignacionClave: false,
    asignacion_clave: {
      token: { campo: "", valido: false },
      email: { campo: "", valido: false },
      password: { campo: "", valido: false },
      password_confirmation: { campo: "", valido: false }
    },
    asignar_clave: false,
    mensaje_proceso: false,
    mensaje_ok: false,
    mensaje_error: false,
    error: false,
    procesando: true,
    url_action: "/traslado/representantes/login",
    inputRules: [v => !!v || "Campo es requerido"],
    emailRules: [
      v =>
        /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/.test(v) ||
        "Debe digitar un correo electrónico válido"
    ],
    passwordRules: [
      v =>
        /(?=^.{8,}$)((?=.*\d)(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/.test(
          v
        ) ||
        "Digite mínimo 8: (Mayúsculas, minúsculas, numeros, carácteres especiales)"
    ]
  }),
  props: ["token"],
  created() {
    this.initialize();
  },
  mounted() {
    let parameters = this.$route.query;

    this.asignacion_clave.token.campo = this.token;
    this.asignacion_clave.email.campo = parameters.p1;
  },
  components: {},
  computed: {},
  watch: {},
  methods: {
    initialize() {},
    asignarNuevaClave() {
      this.asignar_clave = true;
      this.mensaje_proceso = true;
      this.mensaje_ok = false;
      this.mensaje_error = false;

      let representante = {
        token: this.asignacion_clave.token.campo,
        email: this.asignacion_clave.email.campo,
        password: this.asignacion_clave.password.campo,
        password_confirmation: this.asignacion_clave.password_confirmation.campo
      };

      console.log(representante);

      Usuario.asignarNuevaClave(representante).then(response => {
        console.log(response);
        this.mensaje_proceso = false;
        if (response) {
          this.mensaje_ok = true;
          this.mensaje_error = false;
        } else {
          this.mensaje_ok = false;
          this.mensaje_error = true;
        }
      });
    },
    login() {
      router.push({
        name: "traslado-representantes"
      });
    }
  }
};
</script>
<style lang="css" scoped>
.estilo_dos_columnas {
  width: 50%;
  margin-left: 5px;
  margin-top: 5px;
}
.estilo_tres_columnas {
  width: 33%;
  padding-right: 10px;
  padding-top: 15px;
}
</style>
